import { GET_CANCELLED_STUDIES } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getCancelledStudiesApi = createAsyncThunk('getCancelledStudiesApi', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const url = `${GET_CANCELLED_STUDIES}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      //body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return Promise.reject(error.message || 'Something went wrong');
  }
});

export default getCancelledStudiesApi;
